exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2BaOyZiUcojWfXUmUmkYch{min-height:100vh;display:flex;flex-direction:column}", ""]);

// exports
exports.locals = {
	"app": "_2BaOyZiUcojWfXUmUmkYch"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/less-loader!./src/components/App/styles.less
// module id = 112
// module chunks = 0